export const LIFECYCLE_DRAFT = 'draft';
export const LIFECYCLE_CANCELLED = 'cancelled';
export const LIFECYCLE_SCHEDULED = 'scheduled';
export const LIFECYCLE_ACTIVE = 'active';

/** Training session statuses that allow student assignment. */
export const ASSIGNABLE_SESSION_STATUSES = new Set([LIFECYCLE_SCHEDULED, LIFECYCLE_ACTIVE]);

export const isDraftStatus = status => status === LIFECYCLE_DRAFT;

export const isCancelledStatus = status => status === LIFECYCLE_CANCELLED;

export const isComputedLifecycleStatus = status =>
  Boolean(status) && !isDraftStatus(status) && !isCancelledStatus(status);

export const canLaunchEntity = status => isDraftStatus(status);

/** Mutually exclusive with launch: only for launched (non-draft) entities that are not already cancelled. */
export const canCancelEntity = status => Boolean(status) && !isDraftStatus(status) && !isCancelledStatus(status);

export const canAssignParticipantsToSession = status => ASSIGNABLE_SESSION_STATUSES.has(status);

export const getLifecycleStatusLabel = (t, i18nPrefix, status) => {
  if (!status) {
    return '';
  }
  return t(`${i18nPrefix}.${status}`, { defaultValue: status });
};
